export const GTM_ID = "GTM-W2Z74JQ";

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const pageview = (url: any) => {
  if (
    typeof window !== "undefined" &&
    window.dataLayer &&
    process.env.NEXT_PUBLIC_DISABLE_ANALYTICS !== "true"
  ) {
    window.dataLayer.push({
      event: "pageview",
      page: url,
    });
  }
};
